import { createEvent } from "library/local-events/index.mjs"

// Lightweight hover-linkage signal shared between the comments panel (thread cards) and the
// in-document text highlights. Raising it with a comment id tells both surfaces which comment is
// currently "focused" so they can lift its emphasis; raising it with null clears the focus. The
// payload is a single id (or null) — never a large object — per the events best-practice of
// carrying signals, not data.
//
// Co-located `.mjs` so it can be imported by the client `.js` components here. Both the panel card
// and the highlight delegation toggle a data attribute / class in response rather than forcing a
// React re-render, keeping the linkage cheap.
export const ShareLinkCommentFocus = createEvent("ShareLinkCommentFocus")
